import axios from "axios";

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "api/v2"
      : "http://localhost:3001/api/v2",
});

export default instance;

export const authIsValid = (message) => {
  if (message === "Authorization expired. Log in again.") {
    return false;
  } else if (
    message === "You don't have the authority to perform that action."
  ) {
    alert(message);
    return false;
  }
  return true;
};
